"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _url = require("url");
var _anypointFetch = _interopRequireDefault(require("@mulesoft/anypoint-fetch"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var cardStyles = {
  "container": "AssetCard__container__1teJw",
  "asset-title": "AssetCard__asset-title__3WiAo",
  "assetTitle": "AssetCard__asset-title__3WiAo",
  "asset-card": "AssetCard__asset-card__2iQEf",
  "assetCard": "AssetCard__asset-card__2iQEf",
  "override": "AssetCard__override__33nJK",
  "description": "AssetCard__description__3MpvF",
  "version": "AssetCard__version__1Abn0",
  "detail": "AssetCard__detail__29UNK",
  "rating": "AssetCard__rating__2yb0N",
  "name": "AssetCard__name__1vrTi",
  "icon": "AssetCard__icon__AoJmh",
  "tags-container": "AssetCard__tags-container__2t7B7",
  "tagsContainer": "AssetCard__tags-container__2t7B7",
  "matches-tags": "AssetCard__matches-tags__1ABXA",
  "matchesTags": "AssetCard__matches-tags__1ABXA",
  "matches-categories": "AssetCard__matches-categories__1PQSu",
  "matchesCategories": "AssetCard__matches-categories__1PQSu",
  "matches-table": "AssetCard__matches-table__3KrTq",
  "matchesTable": "AssetCard__matches-table__3KrTq",
  "row-title": "AssetCard__row-title__1EWa5",
  "rowTitle": "AssetCard__row-title__1EWa5",
  "row-content": "AssetCard__row-content__18NmT",
  "rowContent": "AssetCard__row-content__18NmT",
  "metadata": "AssetCard__metadata__1HjVL",
  "number-of-rates": "AssetCard__number-of-rates__2AViT",
  "numberOfRates": "AssetCard__number-of-rates__2AViT",
  "metadata-item": "AssetCard__metadata-item__2ztCa",
  "metadataItem": "AssetCard__metadata-item__2ztCa",
  "metadata-item-wrapper": "AssetCard__metadata-item-wrapper__DMBFE",
  "metadataItemWrapper": "AssetCard__metadata-item-wrapper__DMBFE"
}; 
require('../AssetCard.css');
var styles = {
  "loader-wrapper": "Pages__loader-wrapper__3-3yk",
  "loaderWrapper": "Pages__loader-wrapper__3-3yk"
}; 
require('./Pages.css');
var getRandomInteger = function getRandomInteger(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
};
var getPageTitleText = function getPageTitleText(title) {
  if (title === 'home') {
    return 'Home page';
  }
  if (title === '.terms') {
    return 'Terms and conditions';
  }
  return title;
};
var LoadingPage = function LoadingPage(_ref) {
  var width = _ref.width;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.loaderWrapper,
    "data-test-id": "match-pages-loading"
  }, /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, {
    height: 18,
    viewBox: "0 0 120 20"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: 0,
    y: 0,
    rx: 3,
    ry: 3,
    width: width,
    height: 20
  })));
};
LoadingPage.propTypes = {
  width: _propTypes.default.number.isRequired
};
var Pages = function Pages(_ref2) {
  var pages = _ref2.pages,
    isExpanded = _ref2.isExpanded,
    fetchPagesPromise = _ref2.fetchPagesPromise,
    initialTitleWidths = _ref2.titleWidths,
    onFetchStart = _ref2.onFetchStart,
    onFetchEnd = _ref2.onFetchEnd,
    hasFetchedPages = _ref2.hasFetchedPages,
    groupId = _ref2.groupId,
    assetId = _ref2.assetId,
    minorVersion = _ref2.minorVersion,
    searchTerm = _ref2.searchTerm;
  var config = (0, _exchangeReactHooks.useConfig)();
  var tryFn = (0, _exchangeReactHooks.useTryFn)();
  var fetch = (0, _anypointFetch.default)({
    config: config
  });
  var titleWidths = initialTitleWidths || [];
  function loadPages(_x) {
    return _loadPages.apply(this, arguments);
  }
  function _loadPages() {
    _loadPages = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2($fetchPagesPromise) {
      var promise, fetchedPages;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            promise = $fetchPagesPromise;
            if (!$fetchPagesPromise) {
              promise = tryFn( /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(context) {
                  var url, response, result;
                  return _regenerator.default.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        url = (0, _url.format)(_objectSpread(_objectSpread({}, config.api.uri), {}, {
                          pathname: "".concat(config.api.uri.pathname || '', "/api/v2/assets/").concat(groupId, "/").concat(assetId, "/minorVersions/").concat(minorVersion, "/portal/pages"),
                          query: {
                            search: searchTerm
                          }
                        }));
                        _context.next = 3;
                        return fetch(url, {
                          context: context
                        });
                      case 3:
                        response = _context.sent;
                        _context.next = 6;
                        return response.json();
                      case 6:
                        result = _context.sent;
                        return _context.abrupt("return", result);
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());
              onFetchStart(promise, titleWidths);
            }
            _context2.next = 4;
            return promise;
          case 4:
            fetchedPages = _context2.sent;
            onFetchEnd(fetchedPages);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _loadPages.apply(this, arguments);
  }
  _react.default.useEffect(function () {
    if (isExpanded && !hasFetchedPages || fetchPagesPromise) {
      loadPages(fetchPagesPromise);
    }
  }, [isExpanded]);
  return /*#__PURE__*/_react.default.createElement("table", {
    className: cardStyles.matchesTable,
    "data-test-id": "asset-card-pages"
  }, /*#__PURE__*/_react.default.createElement("tbody", null, pages.map(function (page, index) {
    var pageTitle;
    if (page.title) {
      pageTitle = /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, getPageTitleText(page.title));
    } else {
      if (!titleWidths[index]) {
        titleWidths[index] = getRandomInteger(60, 140);
      }
      pageTitle = /*#__PURE__*/_react.default.createElement(LoadingPage, {
        width: titleWidths[index]
      });
    }
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: "page-".concat(index)
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: cardStyles.rowTitle
    }, pageTitle), /*#__PURE__*/_react.default.createElement("td", {
      className: cardStyles.rowContent
    }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, page.content)));
  })));
};
Pages.defaultProps = {
  pages: [],
  titleWidths: null,
  isExpanded: false,
  onFetchStart: function onFetchStart() {},
  onFetchEnd: function onFetchEnd() {},
  fetchPagesPromise: null,
  hasFetchedPages: false
};
Pages.propTypes = {
  pages: _propTypes.default.arrayOf(_propTypes.default.object),
  isExpanded: _propTypes.default.bool,
  onFetchStart: _propTypes.default.func,
  titleWidths: _propTypes.default.arrayOf(_propTypes.default.number),
  onFetchEnd: _propTypes.default.func,
  fetchPagesPromise: _propTypes.default.object,
  hasFetchedPages: _propTypes.default.bool,
  assetId: _propTypes.default.string.isRequired,
  groupId: _propTypes.default.string.isRequired,
  minorVersion: _propTypes.default.string.isRequired,
  searchTerm: _propTypes.default.string.isRequired
};
var _default = exports.default = Pages;
//# sourceMappingURL=Pages.js.map